import { render, staticRenderFns } from "./ModalCommandAsk.vue?vue&type=template&id=50408cf6&scoped=true"
import script from "./ModalCommandAsk.vue?vue&type=script&lang=js"
export * from "./ModalCommandAsk.vue?vue&type=script&lang=js"
import style0 from "./ModalCommandAsk.vue?vue&type=style&index=0&id=50408cf6&prod&scoped=true&lang=css"


/* normalize component */
import normalizer from "!../../../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  "50408cf6",
  null
  
)

export default component.exports